import React, { useState } from "react";
import { Button } from "antd";
import { ColumnType } from "antd/lib/table";
import { find, isNil, size } from "lodash";
import { EComModal } from "components/EComModal";
import { AiccLessonReviewScript, AiccLessonReviewScriptUploadPreview } from "types/model/aiccLearningAssets";
import SharedUploadPreviewModal from "../UploadPreviewModal";
import LessonScripts, { getLessonScriptTitle } from "./LessonScripts";
import styles from "./LessonReviewScript.module.scss";

interface Props {
  visible: boolean;
  fileName?: string;
  preview?: AiccLessonReviewScriptUploadPreview;
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const previewColumns: ColumnType<AiccLessonReviewScript>[] = [
  { title: "Level", dataIndex: "level", key: "level", width: 100 },
  { title: "Lesson", dataIndex: "lesson", key: "lesson", width: 100 },
  {
    title: "Scripts Count",
    key: "scriptsCount",
    width: 140,
    render: (_: unknown, { scripts }: AiccLessonReviewScript) => size(scripts),
  },
];

function UploadPreviewModal({ visible, fileName, preview, isSaving, onCancel, onConfirm }: Props) {
  const [reviewedId, setReviewedId] = useState<string>();

  const lessons = preview?.rows ?? [];
  const reviewedLesson = find(lessons, { id: reviewedId });

  const actionColumn: ColumnType<AiccLessonReviewScript> = {
    title: "Action",
    key: "action",
    width: 100,
    render: (_: unknown, { id }: AiccLessonReviewScript) => (
      <Button type="link" className={styles.reviewLink} onClick={() => setReviewedId(id)}>
        Review
      </Button>
    ),
  };

  return (
    <SharedUploadPreviewModal<AiccLessonReviewScript>
      visible={visible}
      fileName={fileName}
      preview={preview}
      rows={lessons}
      columns={previewColumns}
      trailingColumns={[actionColumn]}
      rowKey="id"
      summary={`${size(
        lessons
      )} lessons are ready to upload. Uploading replaces all current content for this language.`}
      isSaving={isSaving}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <EComModal
        visible={!isNil(reviewedLesson)}
        width={880}
        title={reviewedLesson ? getLessonScriptTitle(reviewedLesson) : ""}
        footer={null}
        onCancel={() => setReviewedId(undefined)}
      >
        <LessonScripts scripts={reviewedLesson?.scripts} />
      </EComModal>
    </SharedUploadPreviewModal>
  );
}

export default UploadPreviewModal;
